import React from 'react';
import './Dashboard.css';

function OrganInfo() {
    return (
        <div className="dashboard-container">
            <header className="dashboard-header card">
                <div className="welcome-text">
                    <h1>Organ Information</h1>
                    <p>Manage organ-related information and data</p>
                </div>
            </header>

            {/* <div className="info-sections">
                <section className="info-card card">
                    <div className="info-header">
                        <h3>Organ Information</h3>
                    </div>
                    <div className="info-content-grid">
                        <p>Organ information management interface will be implemented here.</p>
                    </div>
                </section>
            </div> */}
        </div>
    );
}

export default OrganInfo;
